<template>
	<div class="achievements-block">
		<div class="default-block-title">
			{{ t.mainPoints }}
		</div>

		<div v-show="userPoints === false || userTotalPoints === false" class="spinner">
			<loader />
		</div>

		<div v-show="!(userPoints === false || userTotalPoints === false)">
			<points-block class="points" />
			<div class="total-points">
				<span v-html="t.achievementsTotalPointsHtml" />
				<points-lifetime />
			</div>
		</div>

		<champion-monthly v-if="isInMonthlyTop" v-show="!showPointsLoader" :monthly-top-url="monthlyTopUrl" @loaded="showPointsLoader = false" />
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import PointsLifetime from './points-lifetime.vue'
import ChampionMonthly from './champion-monthly.vue'
import PointsBlock from './points-block.vue'
import { useStore } from '@/js/stores/index';
import { useUserStore } from '@/js/stores/user';

const store = useStore()
const userStore = useUserStore()

// Reactives
const showPointsLoader = ref(true)

// Props
defineProps({
	isInMonthlyTop: Boolean,
	monthlyTopUrl: {
		type: [String, Boolean],
		required: false,
		default: '',
	},
})

// Computeds
const t = computed(() => store.translations)
const userPoints = computed(() => userStore.userPoints)
const userTotalPoints = computed(() => userStore.userTotalPoints)
</script>

<style scoped>
	.spinner{
		position: inherit;
		height: 60px;
		line-height: 60px;
	}
</style>